import React from 'react'
import TextCaption from '../Components/TextCaption/TextCaption'
import { Helmet } from 'react-helmet-async'
import { useTranslation } from 'react-i18next'
import SectionHeader from '../Components/SectionHeader/SectionHeader'
import CenterStage from '../Components/CenterStage/CenterStage'
import imgTermsandcondition from '../assets/WhoWeAre/stage.jpg'


const TERMS_PDF_PATH = '/PDF_folder/Condicoes-de-Venda-e-Garantia.pdf';
const TERMS_PDF_FILENAME = 'Condicoes-de-Venda-e-Garantia.pdf';

const termsandcondition = () => {
  const handleDownloadPdf = async (e) => {
    e.preventDefault();
    const pdfUrl = `${process.env.PUBLIC_URL || ''}${TERMS_PDF_PATH}`;

    try {
      const response = await fetch(pdfUrl);
      if (!response.ok) throw new Error('PDF not found');

      const contentType = response.headers.get('content-type') || '';
      if (contentType.includes('text/html')) throw new Error('Invalid PDF response');

      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = TERMS_PDF_FILENAME;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(blobUrl);
    } catch {
      window.open(pdfUrl, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <div>

      <CenterStage imageSrc={imgTermsandcondition} title="GENERAL TERMS OF SALE AND WARRANTY" paragraph="(Date: 10/04/2026)" 
      buttonName="Download PDF"
      buttonLink={TERMS_PDF_PATH}
      />

      <TextCaption
        title="1. COMPANY IDENTIFICATION"
        paragraph="HANSA-FLEX DO BRASIL LTDA., hereinafter referred to as HANSA-FLEX, a private legal entity established in Brazil, is engaged in the sale, manufacture, assembly, and provision of services related to hydraulic hoses, fittings, industrial components, and hydraulic and pneumatic systems."
      />
      <TextCaption
        title="2. SCOPE OF APPLICATION"
        paragraph="2.1. These General Terms and Conditions of Sale and Warranty (GTCS) apply to all proposals, quotations, orders, contracts, deliveries, and services provided by HANSA-FLEX, unless otherwise specifically agreed in writing."
      />

      <TextCaption
        paragraph="2.2. By contracting with HANSA-FLEX, the customer declares that they have read, understood, and fully accepted these terms, which supersede the CONTRACTING PARTY’s general terms, even if included in the order accepted by HANSA-FLEX."
      />

      <TextCaption
        title="3. PROPOSALS AND ORDERS"
        paragraph="3.1. Commercial proposals are valid for a limited time, as indicated in the proposal document."
      />

      <TextCaption
        paragraph="3.2. Orders shall only be considered accepted after formal confirmation by HANSA-FLEX, in writing or by electronic means."
      />

      <TextCaption
        paragraph="3.3. Changes requested after order acceptance shall be subject to a new technical review, price adjustments, and revised delivery times."
      />

      <TextCaption
        paragraph="3.4. Orders may not be canceled without the express consent of HANSA-FLEX. Cancellations of orders for products manufactured exclusively for the CONTRACTING PARTY will not be accepted."
      />

      <TextCaption
        title="4. PRICES"
        paragraph="4.1. Prices are expressed in Brazilian reais (R$), unless otherwise specified in the proposal."
      />

      <TextCaption
        paragraph="4.2. Prices include applicable taxes, which will be itemized in commercial proposals, orders, and related tax documents, in accordance with current legislation."
      />

      <TextCaption
        paragraph="4.3. HANSA-FLEX reserves the right to adjust prices in the event of"
      />
      <TextCaption
        bulletPoints={[
          "exchange rate fluctuations;",
          "tax changes;",
          "significant increases in raw material costs;",
          "force majeure events.",
        ]} />

      <TextCaption
        title="5. PAYMENT TERMS"
        paragraph="5.1. Payment terms will be specified in the commercial proposal or invoice."
      />
      <TextCaption
        paragraph="5.2. Failure to pay by the due date will result in -"
        bulletPoints={[
          "late payment interest of 1% per month;",
          "monetary adjustment calculated based on the INPC index;",
          "a late payment penalty of 2% (two percent) calculated on the amount plus interest and monetary adjustment;",
          "suspension of supplies and services for the duration of the default, or termination of the CONTRACT if the suspension lasts for more than 30 (thirty) days.",
          "the possibility of suspending new supplies.",
        ]}
      />

      <TextCaption
        paragraph="5.3. In the event of judicial or extrajudicial collection, the CONTRACTING PARTY shall reimburse the CONTRACTOR for any and all expenses arising from the collection measures, including attorneys’ fees."
      />


      <TextCaption
        title="6. DELIVERY TIMES"
        paragraph="6.1. The delivery times stated in the quotation are estimates, calculated from the date of order confirmation and the customer’s fulfillment of the terms and conditions."
      />

      <TextCaption
        paragraph="6.2. HANSA-FLEX shall not be liable for delays resulting from"
        bulletPoints={[
          "unforeseeable circumstances or force majeure, as defined in the sole paragraph of Article 393 of the Brazilian Civil Code, which demonstrably affect the SUPPLY;",
          "failure by the CONTRACTING PARTY, or by third parties under its responsibility, to comply with any obligations, which may hinder the fulfillment of the SUPPLY deadlines;",
          "delays by third parties and carriers directly related to the supply and/or delivery;",
          "incorrect information provided by the customer",
          "legal or logistical impediments.",
        ]}
      />

      <TextCaption
        paragraph="6.3. The delivery deadline shall be deemed met when - a) the SUPPLY has been provided, and/or b) the SUPPLY has been shipped or made available by the CONTRACTOR, when the CONTRACTING PARTY is responsible for transportation."
      />

      <TextCaption
        title="7. TRANSFER OF RISK AND OWNERSHIP"
        paragraph="7.1. Risk in the products passes to the customer upon delivery to the carrier or upon pickup at the HANSA-FLEX facility."
      />

      <TextCaption
        paragraph="7.2. Ownership shall pass to the CONTRACTING PARTY upon full payment of the price as specified in the proposal/order/contract."
      />
      <TextCaption
        title="8. WARRANTY"
        paragraph="8.1. HANSA-FLEX warrants that the SUPPLY will comply with the technical specifications set forth in the proposal and will be free from defects in materials and workmanship, provided it is used properly. “Proper use” means use, installation, operation, and maintenance in accordance with HANSA-FLEX’s instructions."
      />

      <TextCaption
        paragraph="8.2. The warranty period is"
        bulletPoints={[
          "90 (ninety) days for products and services, unless a different period is specified in the contract or required by law.",
        ]}
      />


      <TextCaption
        paragraph="8.3. The warranty covers only manufacturing or assembly defects, provided they are technically verified."
      />

      <TextCaption
        title="9. WARRANTY EXCLUSIONS"
        paragraph="The warranty does not cover:"
      />
      <TextCaption
        paragraph="a) normal wear and tear;"
      />

      <TextCaption
        paragraph="b) improper use or operation, or use outside the technical specifications provided by HANSA-FLEX;"
      />
      <TextCaption
        paragraph="c) incorrect installation;"
      />
      <TextCaption
        paragraph="d) improper or lack of maintenance;"
      />
      <TextCaption
        paragraph="e) modifications made without HANSA-FLEX’s authorization;"
      />
      <TextCaption
        paragraph="f) damage caused by external factors, such as:"
        bulletPoints={[
          "overpressure",
          "fluid contamination",
          "mechanical impacts",
          "fire, flooding, or accidents",

        ]}
      />

      <TextCaption
        title="10. LIABILITY"
        paragraph="10.1. HANSA-FLEX’s liability is limited to repair, replacement, or a proportional refund of the value of the defective product or service."
      />

      <TextCaption

        paragraph="10.2. Under no circumstances shall HANSA-FLEX be liable for"
        bulletPoints={[
          "lost profits;",
          "indirect losses;",
          "production downtime;",
          "consequential damages.",

        ]}
      />
      <TextCaption
        paragraph="10.3. HANSA-FLEX’s aggregate liability for damages or for any breach of contract or tort, for any losses and damages, including property damage, fines, penalties, termination, indemnification, reimbursements, and compensation, is limited, regardless of the number of occurrences, to 40% (forty percent) of the total order value."
      />


      <TextCaption
        title="11. RETURNS AND COMPLAINTS"
        paragraph="11.1. Any complaints must be submitted in writing within seven (7) days of receiving the product."
      />

      <TextCaption
        paragraph="11.2. Returns will only be accepted with prior authorization from HANSA-FLEX."
      />

      <TextCaption
        paragraph="11.3. Custom-made or personalized products may not be returned, except in cases of proven defects."
      />

      <TextCaption
        title="12. INTELLECTUAL PROPERTY"
        paragraph="12.1. All designs, drawings, technical specifications, patents, trademarks, and know-how, trade secrets, and any other information provided by HANSA-FLEX for the purpose of fulfilling the supply are its exclusive property."
      />

      <TextCaption
        paragraph="12.2. Reproduction, disclosure, or use without express authorization is prohibited."
      />

      <TextCaption
        title="13. CONFIDENTIALITY"
        paragraph="13.1. The parties undertake to keep confidential all technical, commercial, and strategic information obtained as a result of the business relationship."
      />

      <TextCaption
        paragraph="13.2. Technical information shall be kept confidential by the CONTRACTING PARTY, its employees, agents, or subcontractors and shall be used by them solely for the purposes of operating and maintaining the SUPPLY."
      />

      <TextCaption
        title="14. FORCE MAJEURE"
        paragraph="HANSA-FLEX shall not be liable for failures or delays resulting from unforeseeable or unavoidable events, such as strikes, pandemics, natural disasters, government actions, or supply disruptions."
      />

      <TextCaption
        title="15. GOVERNING LAW AND JURISDICTION"
        paragraph="15.1. These Terms and Conditions are governed by the laws of the Federative Republic of Brazil."
      />

      <TextCaption
        paragraph="15.2. The courts of the district where HANSA-FLEX DO BRASIL has its headquarters shall have exclusive jurisdiction, and the parties hereby expressly waive any other jurisdiction, however preferential it may be."
      />

      <TextCaption
        title="16. FINAL PROVISIONS"
        paragraph="16.1. The invalidity of any provision shall not affect the others."
      />

      <TextCaption
        paragraph="16.2. Tolerance of non-compliance with obligations does not imply a waiver of rights."
      />

      <div style={{ paddingLeft: '15%', paddingRight: '15%', paddingTop:'3%'}}>
        <div style={{ paddingBottom:'10px' }}>HANSA-FLEX BRASIL</div>
        <div style={{ paddingBottom:'10px' }}>Rod. BR 470, 2461 Itoupavazinha</div>
        <div style={{ paddingBottom:'10px' }}>89066-010</div>
        <div style={{ paddingBottom:'10px' }}>Blumenau/SC – Brazil</div>
        <div style={{ paddingBottom:'10px' }}>Tel.:  +55 47 3321 6300</div>
        <div style={{ paddingBottom:'10px' }}>Email:  bbl@hansa-flex.com</div>
        <button type="button" className="btn btn-danger" onClick={handleDownloadPdf}>
          Download PDF
        </button>
      </div>

      <br /><br /><br />
    </div>
  )
}

export default termsandcondition